module.exports = __webpack_public_path__ + "img/1N.fb71de0a.jpg";